<template>
    <div class="modal" style="z-index: 999999;">
        <div class="modal__container">
            <div class="modal__inner  modal__inner--secondary">

                <!-- <h3 class="modal__ttl  modal__ttl--primary"></h3> -->
                <h4 class="modal__ttl  modal__ttl--primary">Ticket added to Order</h4>

                <div class="modal__content">
                    <button class="btn  btn--quaternary" @click.prevent="close">
                        <span>{{ __('Add another Ticket') }}</span>
                    </button>

                    <button class="btn  btn--quaternary" @click.prevent="returnToOrder">
                        <span>{{ __('Return to Order') }}</span>
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'seat-picker-seat-added-modal',

        props: {
            orderId: {
                type: Number,
                default: false
            }
        },

        data: (instance) => {
            return {
            }
        },
        methods: {
            returnToOrder() {
                window.location.replace('/admin/orders/show/' + this.orderId)
            },
            close() {
                this.$emit('close', true);
            },
        }
    }
</script>
<style lang="scss" scoped>
    .modal__content {
        text-align: center;
    }
    h4{
        &.modal__ttl--primary{
            font-size: 24px;
        }
    }
    .modal__close{
        margin-top: 40px;
    }
    option {
        color: #000;
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPickerSeatAddedModal.vue